import { render, staticRenderFns } from "./archiveTypeDetails.vue?vue&type=template&id=5db0219c&"
import script from "./archiveTypeDetails.vue?vue&type=script&lang=js&"
export * from "./archiveTypeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports